import { Tooltip } from 'antd';
import { QuestionOutlined,  ExclamationOutlined, ExclamationCircleOutlined, WarningOutlined, StopOutlined } from '@ant-design/icons';

export const taskPriorityIcons: Record<number, React.ReactNode> = {
    1: (
        <Tooltip title="Тривиальный: Не относится к логике приложения и не влияет на общее качество продукта.">
            <QuestionOutlined />
        </Tooltip>
    ),
    2: (
        <Tooltip title="Незначительный: Не нарушает логику приложения.">
            <ExclamationOutlined />
        </Tooltip>
    ),
    3: (
        <Tooltip title="Значительный: Часть логики работает некорректно, но пользователь может решить проблему другим способом.">
            <WarningOutlined />
        </Tooltip>
    ),
    4: (
        <Tooltip title="Критический: Часть функционала не работает, но это не блокирует процесс.">
            <ExclamationCircleOutlined />
        </Tooltip>
    ),
    5: (
        <Tooltip title="Блокирующий: Приложение не запускается ни на одном устройстве или выдаёт ошибку при загрузке.">
            <StopOutlined />
        </Tooltip>
    ),
};

export const taskNumberPriorityIcons: Record<number, React.ReactNode> = {
    1: (
        <Tooltip title="Тривиальный: Не относится к логике приложения и не влияет на общее качество продукта.">
            1
        </Tooltip>
    ),
    2: (
        <Tooltip title="Незначительный: Не нарушает логику приложения.">
            2
        </Tooltip>
    ),
    3: (
        <Tooltip title="Значительный: Часть логики работает некорректно, но пользователь может решить проблему другим способом.">
            3
        </Tooltip>
    ),
    4: (
        <Tooltip title="Критический: Часть функционала не работает, но это не блокирует процесс.">
            4
        </Tooltip>
    ),
    5: (
        <Tooltip title="Блокирующий: Приложение не запускается ни на одном устройстве или выдаёт ошибку при загрузке.">
            5
        </Tooltip>
    ),
};
